module.exports = __webpack_public_path__ + "img/Introduction to Programming.4ee12093.svg";